import { AtomicStatusType } from '../../graphql/generated';

export type ViewStep =
    | 'ATOMIC_RETRY'
    | 'SHORT_TERM_PENDING'
    | 'LONG_TERM_PENDING'
    | 'RETRY'
    | 'DOC_UPLOAD'
    | 'APPROVED';

export const getStepForAtomicStatus = (status: AtomicStatusType): ViewStep => {
    switch (status) {
        case 'VERIFICATION_NEEDS_DOC_UPLOAD':
            return 'DOC_UPLOAD';
        case 'VERIFICATION_FAILED':
            return 'RETRY';
        case 'VERIFICATION_SUCCESSFUL':
        case 'ACCOUNT_COMPLETE':
            return 'APPROVED';
        case 'VERIFICATION_PROCESSING':
        case 'VERIFICATION_DENIED':
        default: {
            return 'LONG_TERM_PENDING';
        }
    }
};
